// extracted by mini-css-extract-plugin
export var scrollArea = "_qy-0";